import app from "/src/app/app.module";
import ContactFormSubmission from "../models/contact-form-submission";

let api = function (settings, $api) {

    const baseUrl = 'v1/contactforms';

    // Optionally pass start/end (epoch seconds) to filter server-side
    const getAll = function (callback, errorCallback, start, end) {
        let url = `${baseUrl}`;
        if (start && end) {
            url += `?start=${start}&end=${end}`;
        }
        $api.get(url, callback, ContactFormSubmission, errorCallback, false);
    };

    const getById = function (id, callback, errorCallback) {
        $api.get(`${baseUrl}/${id}`, callback, ContactFormSubmission, errorCallback);
    };

    const markProcessed = function (id, callback, errorCallback) {
        $api.post(`${baseUrl}/${id}/processed`, callback, {}, null, errorCallback);
    };

    const markUnprocessed = function (id, callback, errorCallback) {
        $api.post(`${baseUrl}/${id}/unprocessed`, callback, {}, null, errorCallback);
    };

    const deleteSubmission = function (id, callback, errorCallback) {
        $api.del(`${baseUrl}/${id}`, callback, errorCallback);
    };

    const lookupCustomer = function (email, phone, callback, errorCallback) {
        $api.post('v1/customers/lookup', callback, {email: email, phone: phone}, null, errorCallback);
    };

    return {
        getAll: getAll,
        getById: getById,
        markProcessed: markProcessed,
        markUnprocessed: markUnprocessed,
        deleteSubmission: deleteSubmission,
        lookupCustomer: lookupCustomer
    };
};

app.factory("$contactForms", api);
